import VIDDSEE_FOR_GOOD_SOCIAL_MEDIA_CARD from './media/viddsee-for-good-social-media-card.jpg';
import IMAGES_STILL_0_ABOUT_BANNER from './media/images/Still_0_About_banner.jpg';
import IMAGES_STILLS_1_DRAMAS from './media/images/Stills_1_dramas.jpg';
import IMAGES_STILLS_2_KATFISH from './media/images/Stills_2_Katfish.jpg';
import IMAGES_STILLS_3_BAKGIA from './media/images/Stills_3_Bakgia.jpg';
import IMAGES_STILLS_4_HTBADC from './media/images/Stills_4_HTBADC.jpg';
import IMAGES_STILLS_5_BTSPICTURE from './media/images/Stills_5_btspicture.jpg';
import IMAGES_STILLS_6_VIDDSEE_DEVICES from './media/images/Stills_6_viddsee_devices.png';
import LOGOS_COMCHEST from './media/logos/Comchest.png';
import LOGOS_ENABLE_ASIA from './media/logos/Enable Asia.png';
import LOGOS_IOMX from './media/logos/iomx.jpg';
import LOGOS_LCC from './media/logos/LCC.png';
import LOGOS_NVPC from './media/logos/NVPC.png';
import LOGOS_THE_HIDDEN_GOOD from './media/logos/the Hidden Good.png';
import LOGOS_TIK_TOK from './media/logos/TikTok.png';
import LOGOS_WWF from './media/logos/WWF.png';
import LOGOS_ZWSG from './media/logos/ZWSG-compact.png';
import PAST_PROJECTS_15SHORTS_2X from './media/past-projects/15shorts@2x.jpg';
import PAST_PROJECTS_GIFT_2X from './media/past-projects/Gift@2x.jpg';
import PAST_PROJECTS_OPEN_DOORS_SINGAPORE_2X from './media/past-projects/open_doors_singapore@2x.jpeg';
import PAST_PROJECTS_STORIESTOGETHER_2X from './media/past-projects/Storiestogether@2x.jpg';
import PAST_PROJECTS_WWF_MY_KOSONG_PLAN_2X from './media/past-projects/WWF My Kosong Plan@2x.jpg';
import PAST_PROJECTS_ADDANEWSTORY from './media/past-projects/addanewstory.jpg';
import PAST_PROJECTS_TSB_FINDING_PURPOSE from './media/past-projects/tsb-finding-purpose.jpg';

export const META_IMAGE = VIDDSEE_FOR_GOOD_SOCIAL_MEDIA_CARD;
export const BACKGROUND_IMAGE = IMAGES_STILL_0_ABOUT_BANNER;
export const WHY_SECTION_IMAGE = IMAGES_STILLS_1_DRAMAS;
export const WHAT_SECTION_IMAGES = [
  IMAGES_STILLS_2_KATFISH,
  IMAGES_STILLS_3_BAKGIA,
  IMAGES_STILLS_4_HTBADC,
];
export const PROJECT_SECTION_IMAGES = [
  PAST_PROJECTS_STORIESTOGETHER_2X,
  PAST_PROJECTS_ADDANEWSTORY,
  PAST_PROJECTS_WWF_MY_KOSONG_PLAN_2X,
  PAST_PROJECTS_TSB_FINDING_PURPOSE,
  PAST_PROJECTS_OPEN_DOORS_SINGAPORE_2X,
  PAST_PROJECTS_GIFT_2X,
  PAST_PROJECTS_15SHORTS_2X,
];
export const PARTNERS_SECTION_IMAGES = [
  LOGOS_IOMX,
  LOGOS_ZWSG,
  LOGOS_ENABLE_ASIA,
  LOGOS_WWF,
  LOGOS_LCC,
  LOGOS_THE_HIDDEN_GOOD,
  LOGOS_TIK_TOK,
  LOGOS_COMCHEST,
  LOGOS_NVPC,
];
export const HOW_SECTION_IMAGES = [
  IMAGES_STILLS_5_BTSPICTURE,
  IMAGES_STILLS_6_VIDDSEE_DEVICES,
];
